<template>
  <v-app>
    <dashboard-core-app-bar :company-name="companyName" />

    <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

    <dashboard-core-view @changeCompanyName="onChangeCompanyName" />
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./AppBar'),
      DashboardCoreDrawer: () => import('./Drawer'),
      DashboardCoreView: () => import('./View'),
    },

    data: () => ({
      expandOnHover: false,
      companyName: null
      // snackbar: {
      //   text: '',
      //   show: false,
      // },
    }),
    // watch: {
    //   '$store.state.snackbar.show': function () {
    //     this.snackbar = this.$store.state.snackbar
    //   },
    // },
    created () {
      this.$watch(
          () => this.$route.params,
          () => this.fetchCustomerName()
      )
    },
    mounted () {
      console.log('Index is mounted')
      console.log('created customerName:', this.$route.query.customerName)
    },
    methods: {
      fetchCustomerName () {
        console.log('fetchCustomerName:', this.$route.query.customerName)
        if (this.$route.query.customerName) {
          this.companyName = this.$route.query.customerName
        }
      },
      onChangeCompanyName (customerShortName) {
        this.companyName = customerShortName
      },
    }
  }
</script>
